// Local (device) storage for unsaved e-prescription drafts.
// One draft per appointment (or per patient UHID when the prescription is
// written from the menu without an appointment), kept in localStorage until the prescription is
// saved, the doctor discards it, or the user logs out.

const DRAFT_PREFIX = 'eprescDraft_';

export class PrescDraftStore {

  static key(appointmentID: any): string {
    return DRAFT_PREFIX + appointmentID;
  }

  static save(appointmentID: any, draft: any): boolean {
    if (appointmentID == null || appointmentID === '') {
      return false;
    }
    try {
      window.localStorage.setItem(this.key(appointmentID), JSON.stringify(draft));
      return true;
    } catch (e) {
      console.log('Draft save failed', e);
      return false;
    }
  }

  static load(appointmentID: any): any {
    if (appointmentID == null || appointmentID === '') {
      return null;
    }
    try {
      const raw = window.localStorage.getItem(this.key(appointmentID));
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.log('Draft load failed', e);
      return null;
    }
  }

  static remove(appointmentID: any): void {
    if (appointmentID == null || appointmentID === '') {
      return;
    }
    try {
      window.localStorage.removeItem(this.key(appointmentID));
    } catch (e) {
      console.log('Draft remove failed', e);
    }
  }

  // Called on logout: drop every stored draft.
  static clearAll(): void {
    try {
      const keys: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k && k.indexOf(DRAFT_PREFIX) === 0) {
          keys.push(k);
        }
      }
      keys.forEach(k => window.localStorage.removeItem(k));
    } catch (e) {
      console.log('Draft clear failed', e);
    }
  }
}
